module.exports = __webpack_public_path__ + "static/img/M-8.b20f887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-8.png
// module id = 0IPj
// module chunks = 0